import alert from './alert.vue'

let $al
const alertInit = (Vue) => {
  if (!$al) {
    let Alert = Vue.extend(alert)
    $al = new Alert({
      el: document.createElement('div')
    })
    document.body.appendChild($al.$el)
  }
}

const alertMethods = {
  warn (text) {
    $al.showMsg('warn', text)
  },
  msg (text) {
    $al.showMsg('msg', text)
  },
  load (text) {
    $al.setLoad(true, text)
  },
  close () {
    $al.setLoad()
  }
}

export default {
  alertInit,
  alertMethods
}
